import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0cfdc40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "h-full w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryHeader = _resolveComponent("PrimaryHeader")!
  const _component_SideMenuLeft = _resolveComponent("SideMenuLeft")!
  const _component_SideMenuRight = _resolveComponent("SideMenuRight")!
  const _component_ProblemDescriptionPage = _resolveComponent("ProblemDescriptionPage")!
  const _component_ProblemStatisticsPage = _resolveComponent("ProblemStatisticsPage")!
  const _component_TopicCommentaryPage = _resolveComponent("TopicCommentaryPage")!
  const _component_PreCommentaryPage = _resolveComponent("PreCommentaryPage")!
  const _component_PostCommentaryPage = _resolveComponent("PostCommentaryPage")!
  const _component_HistoryPage = _resolveComponent("HistoryPage")!
  const _component_ModelAnswerPage = _resolveComponent("ModelAnswerPage")!
  const _component_ReviewViewer = _resolveComponent("ReviewViewer")!
  const _component_EditorPage = _resolveComponent("EditorPage")!
  const _component_JudgeDetailPage = _resolveComponent("JudgeDetailPage")!
  const _component_ReviewPostViewer = _resolveComponent("ReviewPostViewer")!
  const _component_JudgeQueueViewer = _resolveComponent("JudgeQueueViewer")!
  const _component_LoginModal = _resolveComponent("LoginModal")!
  const _component_ArenaModal = _resolveComponent("ArenaModal")!
  const _component_SettingsModal = _resolveComponent("SettingsModal")!
  const _component_UpdateHistoryModal = _resolveComponent("UpdateHistoryModal")!
  const _component_ReviewRequestModal = _resolveComponent("ReviewRequestModal")!
  const _component_DashboardModal = _resolveComponent("DashboardModal")!
  const _component_ProblemSearchModal = _resolveComponent("ProblemSearchModal")!
  const _component_FreeSpaceModal = _resolveComponent("FreeSpaceModal")!
  const _component_UserRegistrationModal = _resolveComponent("UserRegistrationModal")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass(["h-screen w-screen overflow-hidden", {
      'not-select-display slide-cursor': _ctx.frameStatePresenter.isHandlingSlideBar.value,
      'panel-cursor-area': _ctx.editorPageStatePresenter.isHandlingTestFrame,
      'text-gray-800': _ctx.configStatePresenter.isLightMode(),
      'darkScrollBar dark bg-dark-900 text-dark-text border-white': !_ctx.configStatePresenter.isLightMode()
    }]),
    style: _normalizeStyle(`max-height: ${_ctx.configStatePresenter.windowHeight.value}px`)
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_AppLayout, null, {
        default: _withCtx(() => [
          _createVNode(_component_PrimaryHeader, { class: "header-area select step1" }),
          _createVNode(_component_SideMenuLeft, { class: "sidemenu-area-left border-r border-primary-100 dark:border-dark-400" }),
          _createVNode(_component_SideMenuRight, { class: "sidemenu-area-right border-l border-gray-300 dark:border-dark-400" }),
          _createElementVNode("div", {
            class: _normalizeClass(["scrollbar slide-cursor hover:bg-primary", {
            'bg-primary': _ctx.frameStatePresenter.isHandlingSlideBar.value
          }]),
            onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.frameStatePresenter.mouseDownSlideBar && _ctx.frameStatePresenter.mouseDownSlideBar(...args))),
            onMousemove: _cache[1] || (_cache[1] = event => _ctx.frameStatePresenter.resizeLeftSideFrameWidth(event as MouseEvent))
          }, null, 34),
          _createElementVNode("div", {
            id: "problem",
            ref: "leftSideFrameElement",
            class: _normalizeClass(["problem-area border-r flex overflow-y-scroll border-primary-100 dark:border-dark-200", {
            'custom-scrollbar': _ctx.configStatePresenter.isLightMode(),
            'custom-scrollbar-dark': !_ctx.configStatePresenter.isLightMode()
          }]),
            style: _normalizeStyle(_ctx.leftAreaStyle)
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.frameStatePresenter.leftSideFrame.value == 'Problem')
                ? (_openBlock(), _createBlock(_component_ProblemDescriptionPage, {
                    key: 0,
                    class: "py-2 px-4 w-auto",
                    scroll: _ctx.scrollTopLeftPanel
                  }, null, 8, ["scroll"]))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'Statistics')
                ? (_openBlock(), _createBlock(_component_ProblemStatisticsPage, {
                    key: 1,
                    class: "py-2 px-4 w-auto"
                  }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'TopicCommentary')
                ? (_openBlock(), _createBlock(_component_TopicCommentaryPage, {
                    key: 2,
                    class: "py-2 px-4 w-auto",
                    idNumber: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'PreCommentary')
                ? (_openBlock(), _createBlock(_component_PreCommentaryPage, {
                    key: 3,
                    class: "py-5 w-auto"
                  }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'PostCommentary')
                ? (_openBlock(), _createBlock(_component_PostCommentaryPage, {
                    key: 4,
                    class: "py-5 w-auto"
                  }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'History')
                ? (_openBlock(), _createBlock(_component_HistoryPage, { key: 5 }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'ModelAnswer')
                ? (_openBlock(), _createBlock(_component_ModelAnswerPage, { key: 6 }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.leftSideFrame.value == 'Review')
                ? (_openBlock(), _createBlock(_component_ReviewViewer, { key: 7 }))
                : _createCommentVNode("", true)
            ])
          ], 6),
          _createElementVNode("div", {
            ref: "rightSideFrameElement",
            class: _normalizeClass(["editor-area h-full border-l relative min-w-0 border-primary-100 dark:border-dark-200", {
            'overflow-y-auto': _ctx.frameStatePresenter.rightSideFrame.value != 'Editor',
            'custom-scrollbar': _ctx.configStatePresenter.isLightMode(),
            'custom-scrollbar-dark': !_ctx.configStatePresenter.isLightMode()
          }])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.frameStatePresenter.rightSideFrame.value == 'Editor')
                ? (_openBlock(), _createBlock(_component_EditorPage, {
                    key: 0,
                    keySubmmit: _ctx.keySubmmit,
                    keyTest: _ctx.keyTest,
                    shortcutKey: _ctx.nested.shortcutKey,
                    sideMenuWidth: _ctx.frameStatePresenter.leftSideFrameWidth
                  }, null, 8, ["keySubmmit", "keyTest", "shortcutKey", "sideMenuWidth"]))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.rightSideFrame.value == 'JudgeDetail')
                ? (_openBlock(), _createBlock(_component_JudgeDetailPage, {
                    key: 1,
                    class: "w-full h-full"
                  }))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.rightSideFrame.value == 'ReviewPost')
                ? (_openBlock(), _createBlock(_component_ReviewPostViewer, {
                    key: 2,
                    onScroll: _ctx.scrollTopRightPanel
                  }, null, 8, ["onScroll"]))
                : _createCommentVNode("", true),
              (_ctx.frameStatePresenter.rightSideFrame.value == 'JudgeQueue')
                ? (_openBlock(), _createBlock(_component_JudgeQueueViewer, {
                    key: 2,
                    class: "w-full h-full"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (_ctx.modalStatePresenter.isShowLoginModal.value && !_ctx.authStatePresenter.isLogin.value)
            ? (_openBlock(), _createBlock(_component_LoginModal, {
                key: 0,
                login: _ctx.authStatePresenter.login
              }, null, 8, ["login"]))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowArenaModal.value)
            ? (_openBlock(), _createBlock(_component_ArenaModal, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowSettingsModal.value)
            ? (_openBlock(), _createBlock(_component_SettingsModal, {
                key: 2,
                shortcutKey: _ctx.nested.shortcutKey
              }, null, 8, ["shortcutKey"]))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowUpdateModal.value)
            ? (_openBlock(), _createBlock(_component_UpdateHistoryModal, { key: 3 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowReviewAlertModal.value)
            ? (_openBlock(), _createBlock(_component_ReviewRequestModal, { key: 4 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowDashboardModal.value)
            ? (_openBlock(), _createBlock(_component_DashboardModal, { key: 5 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowProblemSearchModal.value)
            ? (_openBlock(), _createBlock(_component_ProblemSearchModal, { key: 6 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowFreeSpaceModal.value)
            ? (_openBlock(), _createBlock(_component_FreeSpaceModal, { key: 7 }))
            : _createCommentVNode("", true),
          (_ctx.modalStatePresenter.isShowUserRegistrationModal.value)
            ? (_openBlock(), _createBlock(_component_UserRegistrationModal, { key: 8 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 6))
}